module.exports = __webpack_public_path__ + "img/flatly.05ef1b9c.png";